// extracted by mini-css-extract-plugin
export default {"associate_section":"Associate_associate_section__4OzBp","asscoiate_logo_wrapper":"Associate_asscoiate_logo_wrapper__zWvds"};